import React from 'react';
import { Clock, TrendingUp, Star, History } from 'lucide-react';
import { NotesSort, SORT_LABELS } from '../../utils/notesFilterUtils';

type Props = {
  sort: NotesSort;
  onChange: (sort: NotesSort) => void;
};

const OPTIONS: { value: NotesSort; icon: React.ElementType }[] = [
  { value: 'newest', icon: Clock },
  { value: 'oldest', icon: History },
  { value: 'downloads', icon: TrendingUp },
  { value: 'rating', icon: Star },
];

const NotesSortBar: React.FC<Props> = ({ sort, onChange }) => (
  <div className="sort-btn-group" role="group" aria-label="Sıralama">
    {OPTIONS.map(({ value, icon: Icon }) => (
      <button
        key={value}
        type="button"
        className={`sort-btn${sort === value ? ' sort-btn--active' : ''}`}
        onClick={() => onChange(value)}
        aria-pressed={sort === value}
        title={SORT_LABELS[value]}
      >
        <Icon size={16} />
        <span className="sort-btn__label">{SORT_LABELS[value]}</span>
      </button>
    ))}
  </div>
);

export default NotesSortBar;
